exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adPrice__price___3o3Dk {\n  color: #f94144;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 23.4px;\n  display: inline-block;\n  white-space: nowrap; }\n\n.adPrice__prevPrice___3sr0r {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 23px;\n  text-decoration-line: line-through;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none; }\n\n@media (max-width: 768px) {\n  .adPrice__prevPrice___3sr0r {\n    font-size: 12px;\n    line-height: 18px; } }\n", ""]);

// exports
exports.locals = {
	"price": "adPrice__price___3o3Dk",
	"prevPrice": "adPrice__prevPrice___3sr0r"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/AdCard/AdSummary/AdPrice/adPrice.scss
// module id = 3894
// module chunks = 6